import React, { useState } from "react";
import { Tabs, Tab, Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import AllWorkOuts from "./AllWorkOuts";
import CreateWorkout from "./CreateWorkout";
import WorkOutDetails from "./WorkOutDetails";


const WorkOutsTabs = () => {
  const [tabs, setTabs] = useState([{ label: "All Workouts", component: "allWorkouts" },{ label: "+ Add Workouts", component: "addWorkouts" }]);
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to Add a New Warehouse Tab
  const handleAddTab = (Workouts) => {
    const existingTab = tabs.find((tab) => tab.id === Workouts.id);
    if (!existingTab) {
      setTabs([...tabs, { id: Workouts.id, label: Workouts.name, component: "WorkoutsDetails", data: Workouts }]);
      setSelectedTab(tabs.length);
    } else {
      setSelectedTab(tabs.findIndex((tab) => tab.id === Workouts.id));
    }
  };

  const handleCloseTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
    
    if (index === selectedTab) {
      if (newTabs.length > 2) {
        setSelectedTab(Math.max(0, index - 1)); // Move to previous tab if available
      } else {
        setSelectedTab(0); // Reset to "All Exercises" if only default tabs remain
      }
    }
  
    setTabs(newTabs);
  };
  
  return (
    <Box sx={{ width: "100%" }}>
      {/* MUI Tabs */}
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{tab.label}</Typography>
                {index > 1 && (
                  <IconButton size="small" onClick={() => handleCloseTab(index)} sx={{ ml: 1 }}>
                    <Close fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ p: 2 }}>
        {tabs[selectedTab].component === "allWorkouts" && <AllWorkOuts onWorkoutsClick={handleAddTab} />}
        {tabs[selectedTab].component === "addWorkouts" && <CreateWorkout />}
        {tabs[selectedTab].component === "WorkoutsDetails" && <WorkOutDetails Workouts={tabs[selectedTab].data} />}
      </Box>
    </Box>
  );
};

export default WorkOutsTabs;
